import {
  RESET_GROUPS,
  GET_GROUPS,
  SET_GROUPS,
  CREATE_GROUPS,
  CREATED_GROUPS,
  API_ERROR,
  GET_GROUP,
  SET_GROUP,
  EDIT_GROUP,
  EDIT_GROUP_SUCCESS,
  DELETE_GROUP,
  DELETE_GROUP_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorGroup: false,
  loadingGroup: false,
  dataGroup: null,
  successGroup: false,
};

const Group = (state = initialState, action) => {
  switch (action.type) {
    case RESET_GROUPS:
      state = {
        ...state,
        errorGroup: false,
        loadingGroup: false,
        successGroup: false,
        loadingDeleteGroup: false,
        successDeleteGroup: false,
      };
      break;
    case GET_GROUPS:
      state = {
        errorGroup: false,
        loadingGroup: true,
        dataGroup: null,
      };
      break;
    case SET_GROUPS:
      state = {
        errorGroup: false,
        loadingGroup: false,
        dataGroup: action.payload,
      };
      break;
    case CREATE_GROUPS:
      state = {
        errorGroup: false,
        loadingGroup: true,
        dataGroup: {...state.dataGroup, ...action.payload},
        successGroup: false,
      };
      break;
    case CREATED_GROUPS:
      state = {
        errorGroup: false,
        loadingGroup: false,
        dataGroup: action.payload,
        successGroup: true,
      };
      break;
    case GET_GROUP:
      state = {
        errorGroup: false,
        loadingGroup: true,
      };
      break;
    case SET_GROUP:
      state = {
        errorGroup: false,
        loadingGroup: false,
        dataGroup: action.payload.data,
      };
      break;
    case EDIT_GROUP:
      state = {
        errorGroup: false,
        loadingGroup: true,
        dataGroup: {...state.dataGroup, ...action.payload},
        successGroup: false,
      };
      break;
    case EDIT_GROUP_SUCCESS:
      state = {
        errorGroup: false,
        loadingGroup: false,
        dataGroup: action.payload,
        successGroup: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorGroup: action.payload,
        loadingGroup: false,
        successGroup: false,
        loadingDeleteGroup: false,
        successDeleteGroup: false,
      };
      break;
    case DELETE_GROUP:
      state = {
        ...state,
        errorGroup: false,
        loadingDeleteGroup: true,
        successDeleteGroup: false,
      };
      break;
    case DELETE_GROUP_SUCCESS:
      state = {
        ...state,
        errorGroup: false,
        dataGroup: action.payload,
        loadingDeleteGroup: false,
        successDeleteGroup: true,
      };
      break;
    default:
      // state = { ...state, errorGroup: false, loadingGroup: false };
      break;
  }
  return state;
};

export default Group;
